import React from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { DurationFormFields } from '../../../../../types/formFieldTypes';
import { clearDurationErrors, durationValidate, initialDurationFields } from '../../formData/DurationFormData';
import { getAntField } from '../../../../../utils/form';
import DurationFormInputs from '../DurationFormInputs/DurationFormInputs';
import { queryKeysDuration } from '../../../../../static/data/queryKeys';
import { invalidateQueries } from '../../../../../utils/rest';


type DurationAddFormProps = {}

const DurationAddForm: React.FC<React.PropsWithChildren<DurationAddFormProps>> = React.memo(() => {

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<DurationFormFields>({
        initialValues: initialDurationFields,
        validateOnChange: false,
        onSubmit: (values) => {
            mutate(values)
        },
        validate: durationValidate
    })

    const antField = getAntField<DurationFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        api.duration.create,
        {
            mutationKey: 'duration-add',
            onSuccess() {
                invalidateQueries(queryKeysDuration[0])
                formStatus.setMessage('Объект успешно добавлен')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.log('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 4000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialDurationFields)
        setErrors(clearDurationErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setTimeout(formStatus.reset, 300)
    }

    return (
        <Form fields={[antField('name')]}>
            <DurationFormInputs
                handleChange={handleChange}
                clearForm={clearForm}
                submitForm={submitForm}
            />
            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default DurationAddForm